import DataService from '../data.service';
class KontaktiAPI {
    many(ids) {
        return DataService.get('kontakt', {
            ids, nopagination: true, pagination: {
                page: 1, pageSize: 200
            }
        })
    }
}

export default new KontaktiAPI();